import { render, staticRenderFns } from "./GameSetting.vue?vue&type=template&id=0b3a9a0e&"
import script from "./GameSetting.vue?vue&type=script&lang=js&"
export * from "./GameSetting.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports